import React from "react";
import { Form, Modal, Spinner, Table } from "react-bootstrap";
import { formatServiceDate, isExpenseCharged, money } from "../BudgetPage.utils";

const ExpenseDetailModal = ({
  budget,
  year,
  getAgentName,
  search,
  onSearchChange,
  expenses,
  filteredExpenses,
  loading,
  error,
  total,
  onHide,
}) => (
  <Modal show={Boolean(budget)} onHide={onHide} size="xl" centered>
    <Modal.Header closeButton>
      <Modal.Title>
        Spese — {budget && getAgentName(budget.idAgente)} · {year}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form.Group className="mb-4">
        <Form.Label>Filtra le spese per mese, agente o costo</Form.Label>
        <Form.Control
          type="search"
          value={search}
          onChange={onSearchChange}
          placeholder="Es. maggio, Rossi o 125,00"
          aria-label="Filtra spese per mese, agente o costo"
        />
        <Form.Text className="text-muted">
          {filteredExpenses.length} risultati su {expenses.length}
        </Form.Text>
      </Form.Group>
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}
      {loading ? (
        <div className="text-center py-6">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <>
          {expenses.length === 0 ? (
            <div className="text-muted text-center py-6">Nessuna spesa per questo agente e anno.</div>
          ) : filteredExpenses.length === 0 ? (
            <div className="text-muted text-center py-6">Nessuna spesa corrisponde al filtro.</div>
          ) : (
            <Table responsive hover>
              <thead>
                <tr>
                  <th style={{ width: "30%" }}>Riferimento</th>
                  <th className="text-right" style={{ width: "13%" }}>
                    Data servizio
                  </th>
                  <th className="text-right" style={{ width: "10%" }}>
                    Stima
                  </th>
                  <th className="text-right" style={{ width: "10%" }}>
                    Costo
                  </th>
                  <th className="text-right" style={{ width: "12%" }}>
                    Addebitato
                  </th>
                  <th style={{ width: "7%" }}>Stato</th>
                </tr>
              </thead>
              <tbody>
                {filteredExpenses.map((expense) => (
                  <tr key={expense.idRichiesta}>
                    <td>
                      <strong>{expense.type}</strong>
                      <div>{expense.titoloEvento || expense.description || "# " + expense.idRichiesta}</div>
                      {/* {expense.description && <div className="small text-muted">{expense.description}</div>} */}
                    </td>
                    <td className="text-nowrap text-right">
                      {formatServiceDate(expense.dataInizio || expense.dateCreated)}
                      {expense.dataFine != null ? " - " : ""}
                      {formatServiceDate(expense.dataFine)}
                    </td>
                    <td className="text-right text-nowrap">{money(expense.stimaCosto)}</td>
                    <td className="text-right text-nowrap">
                      {Number(expense.costo) > 0 ? money(expense.costo) : "—"}
                    </td>
                    <td className="text-right text-nowrap font-weight-bold">{money(expense.importo)}</td>
                    <td>
                      {Number(expense.contabilizzata) === 0 ? (
                        <span
                          className="text-muted"
                          title="Servizio approvato senza riga di budget: importo recuperato dalla richiesta servizio"
                        >
                          Storico
                        </span>
                      ) : Number(expense.attivo) === 1 ? (
                        <span className="text-success">Attiva</span>
                      ) : (
                        <span className="text-muted">Stornata</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
          <div className="text-right font-weight-bold">Totale addebitato: {money(total)}</div>
        </>
      )}
    </Modal.Body>
  </Modal>
);

export default ExpenseDetailModal;
